
<template>
<div>
    <el-alert v-if="status == 3"  :title="`${chanelInfo.reason}:${chanelInfo.remark}`"  type="error"> </el-alert>
    <el-alert v-if="status == 1"  :title="$t('underReview')"  type="warning"> </el-alert>

    <el-form ref="form" :model="form" label-width="120px">
<!-- 渠道类型 -->
      <el-form-item :label="$t('channelType')">
        <el-select v-model="form.grade" :placeholder="$t('pleasechannelType')" :disabled="status == 1">
          <el-option  v-for="(item) in occupation2" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <i class="el-icon-question" @click="showTypeAction"></i>
      </el-form-item>

      <el-form-item :label="$t('name')">
        <el-input type="text" :disabled="status == 1" v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item :label="$t('job')">
        <el-select v-model="form.profession" :placeholder="$t('pleasejob')" :disabled="status == 1">
        <el-option v-for="(item, index) in occupation" :key="index" :label="item" :value="index + 1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('mobilenumber')" >
        <el-input :disabled="status == 1" type="text" v-model="form.mobile"></el-input>
      </el-form-item>

      <el-form-item :label="$t('email')">
        <el-input  :disabled="status == 1" type="text" v-model="form.email"></el-input>
      </el-form-item>

<!-- 所在区域 -->
      <el-form-item :label="$t('address')">
          <el-cascader size="medium" :disabled="status == 1" :options="options" separator=" " 
          :placeholder="$t('pleaseSelect')" v-model="selectedOptions"></el-cascader>
      </el-form-item>

      <!-- 详细地址 -->
      <el-form-item :label="$t('detailedAddress')">
        <el-input type="text" :disabled="status == 1" v-model="form.user_address"></el-input>
      </el-form-item>

     <!-- 身份证正面 -->

      <el-form-item :label="$t('idCardF')" >
          <div class="avatar-uploader">
                <div class="el-upload el-upload--text"> 
                  <input
                  :disabled="status == 1"
                    type="file"
                    class="input-file"
                    name="avatar"
                    ref="avatarInput"
                    @change="changeImage($event, 'front_idcard')"
                    accept="image/gif, image/jpeg, image/jpg, image/png"
                  >
                  <i v-if="front_idcard.url" class="el-icon-delete del" @click.stop="delPic('front_idcard')"></i>

                  <img v-if="front_idcard.url" :src="front_idcard.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
          </div>
      </el-form-item>

      <el-form-item :label="$t('idCardB')" >
          <div class="avatar-uploader">
                <div class="el-upload el-upload--text"> 
                  <input
                  :disabled="status == 1"
                    type="file"
                    class="input-file"
                    name="avatar"
                    ref="avatarInput"
                    @change="changeImage($event, 'back_idcard')"
                    accept="image/gif, image/jpeg, image/jpg, image/png"
                  >
                  <i v-if="back_idcard.url" class="el-icon-delete del" @click.stop="delPic('back_idcard')"></i>

                  <img v-if="back_idcard.url" :src="back_idcard.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
          </div>
      </el-form-item>


<!-- 公司信息 -->
       <el-form-item :label="$t('companyInfo')">
        <el-switch v-model="delivery" :disabled="status == 1"></el-switch>
      </el-form-item>
<!-- 公司名称 -->
    <template v-if="delivery">
      <el-form-item :label="$t('companyName')">
        <el-input type="text" v-model="form.company_name" :disabled="status == 1"></el-input>
      </el-form-item>
<!-- 营业执照码 -->
      <el-form-item :label="$t('buslice.code')">
        <el-input type="text" v-model="form.business_license_no" :disabled="status == 1"></el-input>
      </el-form-item>

<!-- 所在区域 -->

      <el-form-item :label="$t('address')">
          <el-cascader size="medium" :placeholder="$t('pleaseSelect')"
           :disabled="status == 1" :options="options" separator=" " v-model="selectedOptionsCom"></el-cascader>
      </el-form-item>
      <!-- 详细地址 -->

      <el-form-item :label="$t('detailedAddress')">
        <el-input type="text" v-model="form.company_address" :disabled="status == 1"></el-input>
      </el-form-item>

      <el-form-item :label="$t('buslice.pic')" >
          <div class="avatar-uploader">
                <div class="el-upload el-upload--text"> 
                  <input
                    :disabled="status == 1"
                    type="file"
                    class="input-file"
                    name="avatar"
                    ref="avatarInput"
                    @change="changeImage($event, 'business_license_img')"
                    accept="image/gif, image/jpeg, image/jpg, image/png"
                  >
                  <i v-if="business_license_img.url" class="el-icon-delete del" @click.stop="delPic('business_license_img')"></i>

                  <img v-if="business_license_img.url" :src="business_license_img.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
          </div>
      </el-form-item>
      </template>



      <el-form-item v-if="status != 1">
          <el-button type="primary" @click="onSubmit">{{$t('apply')}}</el-button>
      </el-form-item>
    </el-form>


    <el-dialog
      :title="$t('channnelType.tips1')"
      :visible.sync="showType"
      width="30%">
      <div class="handbook">  
        <div>{{$t('channnelType.tips2')}}</div>
        <div>{{$t('channnelType.tips3')}}</div>

        <div>{{$t('channnelType.tips4')}}</div>

        <div>{{$t('channnelType.tips5')}}</div>

        <!-- <div>会员制箭馆：以长期会员收费为主要收入的箭馆。</div>
        <div>专家分销商：本公司合作的行内有影响力的人士，专家，教练。</div>
        <div>户外分销商：以户外用品为主要业务的线下商家。</div> -->
      </div>
    </el-dialog>
</div>
</template>

<script>
  import { apiBaseUrl } from "@/config/env.js";
  import * as locationData from "@/utils/location.js";

  export default {
    data() {
      return {
        delivery: false,
        form: {
          grade: 0,
          id:'',//表单id
          name: '',
          mobile: '', // 联系方式
          profession: 1 ,// 职位
          email: '' ,// 邮箱
          area_id: '' ,// 所在地区
          user_address: '' ,// 详细地址
          front_idcard: '', // 正面
          back_idcard: '' ,// 反面
          company_name: '', // 公司名称
          business_license_no: '', // 营业执照号码
          company_area_id: '', // 所在地区
          company_address: '' ,// 详细地址
          business_license_img: '' ,// 营业执照
          is_main: 2 // 是否为负责人
        },
        upLoadUrl: apiBaseUrl + "api.html",
        occupation2: [], // 渠道类型
        // occupation: [ '老板', '店长', '教练', '业务员'], // 职务
        occupation: [ this.$t('userType.boss'), this.$t('userType.shopManager'),this.$t('userType.coach'),this.$t('userType.salesman')], // 职务

        showType: false,
        cover: [],
        disable: false ,
        options: [], //省市联动数据
        selectedOptions: [],
        provinceKey: 110000, //省份id
        cityKey: 110100, //市id
        areaKey: 110101, //区域idmultiIndex: [110000, 110100, 110101],
        front_idcard: {},
        back_idcard: {},
        chanelInfo: {},
        business_license_img: {},
        status: '',

        selectedOptionsCom: [],
        provinceKeyCom: '',
        cityKeyCom: '',
        areaKeyCom: ''
      }
    },
    mounted() {
      let addressList = this.$storage.get('areaList')
      if (addressList.hasOwnProperty('data')) {
        this.options = addressList.data;
      } else {
        this.options = addressList;
      }
      this.getusergrade()
      this.getInfo()
    },
    watch: {
      data(newVal, oldval) {
        console.log(oldval)
        if (newVal.id) {
          this.init(newVal.area_id);
          this.type = 1;
          this.userName = newVal.name;
          this.telPhone = newVal.mobile;
          this.selectedOptions = this.pickerIndexArr;
          this.selectedOptionsCom = this.pickerIndexArrCom;

          this.form.area_id = this.selectedOptions[2]

          this.detailAddress = newVal.address;
        } else {
          this.type = 0;
        }
      },
      selectedOptionsCom(newVal) {
          this.form.company_area_id = newVal[2]
      },

      selectedOptions(newVal) {
          this.form.area_id = newVal[2]
      }
    },
    computed: {
      pickerIndexArr() {
        this.selectedOptions = [this.provinceKey, this.cityKey, this.areaKey]

        return [this.provinceKey, this.cityKey, this.areaKey];
      },

      pickerIndexArrCom() {
        this.selectedOptionsCom = [this.provinceKeyCom, this.cityKeyCom, this.areaKeyCom]

        return [this.provinceKeyCom, this.cityKeyCom, this.areaKeyCom];
      }
    },
    methods: {
      init(areaId) {
        // this.getFullOptions(areaId, locationData);
      },

      getFullOptionsCom(id, data) {
        for (var i = 0; i < data.length; i++) {
          if (id == data[i].value) {
            if (!data[i].children) {
              this.areaKeyCom = data[i].value - 0;
              return true;
            } else if (data[i].hasOwnProperty("children")) {
              if (data[i].children[0] && !data[i].children[0].children) {
                this.cityKeyCom = data[i].value;
                return true;
              } else {
                this.provinceKeyCom = data[i].value;
                return true;
              }
            }
          } else {
            if (data[i].hasOwnProperty("children")) {
              if (data[i].children[0] !== undefined) {
                if (data[i].children[0].hasOwnProperty("children")) {
                  this.provinceKeyCom = data[i].value;
                } else {
                  this.cityKeyCom = data[i].value;
                }
              }
              if (typeof data[i].children != "undefined") {
                var res = this.getFullOptionsCom(id, data[i].children);
                if (res) {
                  return true;
                }
              }
            }
          }
        }
      },


      getFullOptions(id, data) {
        for (var i = 0; i < data.length; i++) {
          if (id == data[i].value) {
            if (!data[i].children) {
              this.areaKey = data[i].value - 0;
              return true;
            } else if (data[i].hasOwnProperty("children")) {
              if (data[i].children[0] && !data[i].children[0].children) {
                this.cityKey = data[i].value;
                return true;
              } else {
                this.provinceKey = data[i].value;
                return true;
              }
            }
          } else {
            if (data[i].hasOwnProperty("children")) {
              if (data[i].children[0] !== undefined) {
                if (data[i].children[0].hasOwnProperty("children")) {
                  this.provinceKey = data[i].value;
                } else {
                  this.cityKey = data[i].value;
                }
              }
              if (typeof data[i].children != "undefined") {
                var res = this.getFullOptions(id, data[i].children);
                if (res) {
                  return true;
                }
              }
            }
          }
        }
      },
      // 删除图片
      delPic(val) {
        if(this.status == 1) {
          return
        }
        if(val =='front_idcard') {
          this.form.front_idcard = ''
          this.front_idcard = {}
        } else if (val == 'back_idcard') {
          this.form.back_idcard = ''
          this.back_idcard = {}
        } else if (val == 'business_license_img') {
          this.form.business_license_img = ''
          this.business_license_img = {}
        }
      },
      // 图片上传
      changeImage(e, type) {
        const _this = this
        let file = e.target.files[0];
        var formdata = new FormData();
        formdata.append("upfile", file, file.name);
        this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
            if (res.status) {
              this.$data[type] = res.data
              this.form[type] = res.data.image_id
            };
        });
      },
      // 渠道商类型
      showTypeAction() {
        this.showType = true
      },
      // 渠道商列表
      getusergrade() {
        this.$api.getusergrade().then(res => {
          if(res.status) {
            this.occupation2 = res.data
            this.form.grade = res.data[0].id
          }
        })
      },
      onSubmit() {
        this.$api.channelapply(this.form).then( res => {
					if(res.status) {
             this.$message({
              message: res.msg,
              type: 'success'
            })
						this.getInfo()
					} else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
					}
				})
      },
      getInfo() {
          this.$api.channelinfo({apply: true}).then( res => {
          if(res.status) {
            console.log('2131231', res.data)
            let data = res.data
            this.chanelInfo = res.data
            this.status = data.status
            this.check = {
              status_text: data.status_text,
              reason: data.reason,
              remark: data.remark
            }
            this.form = {
              grade: data.grade,
              id:data.id,
              name: data.name,
              mobile: data.mobile, // 联系方式
              profession: data.profession,// 职位
              email: data.email ,// 邮箱
              area_id: data.area_id ,// 所在地区
              user_address: data.user_address ,// 详细地址
              front_idcard: data.front_idcard, // 正面
              back_idcard: data.back_idcard ,// 反面
              company_name: data.company_name, // 公司名称
              business_license_no: data.business_license_no, // 营业执照号码
              company_area_id: data.company_area_id, // 所在地区
              company_address: data.company_address ,// 详细地址
              business_license_img: data.business_license_img ,// 营业执照
              is_main: data.is_main // 是否为负责人
            }
            
            this.occCurrent = data.profession - 1
            // 所在区域

            this.getFullOptions(data.area_id, this.$storage.get('areaList'))
            this.selectedOptions = [this.provinceKey, this.cityKey, this.areaKey]

// data.company_area_id
            this.getFullOptionsCom(data.company_area_id, this.$storage.get('areaList'))
            this.selectedOptionsCom = [this.provinceKeyCom, this.cityKeyCom, this.areaKeyCom]



            // if(data.area_address) {
            //   this.area_id.region = data.area_address.split(' ')
            // }
            // this.area_id.areaId = data.area_id
            // this.area_id.pickerValue = this.area_id.region[0]+ " "+ this.area_id.region[1]+" "+this.area_id.region[2]
            
            
            // if(data.company_area_address) {
            //   this.company_area_id.region = data.company_area_address.split(' ')
            // }
            // this.company_area_id.areaId = data.company_area_id == 0 ? 110101 : data.company_area_id
            // this.company_area_id.pickerValue = this.company_area_id.region[0]+
            // " "+ this.company_area_id.region[1]+" "+this.company_area_id.region[2]
            
            if(data.company_name || data.business_license_no) {
              this.delivery = true
            }
            this.front_idcard = {
              url: data.front_idcard_image || ''
            }
            
            this.back_idcard = {
              url: data.back_idcard_image || ''
            }
            
            this.business_license_img = {
              url: data.business_license_image || ''
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.el-alert {
  margin-bottom: 20px;
}
.handbook{
  div {
    line-height: 50px;
    padding-left: 20px;
  }
}  
.el-form {
  width: 600px;
}
.el-select{
  width: 100%;
}
.el-icon-question{
  position: absolute;
  top: 50%;
  right: -30px;
  transform: translateY(-50%);
  font-size: 22px;
  color: #606266;
  cursor: pointer;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 10px;
  }
.avatar-uploader .el-upload .del{
    position: absolute;
    width: 30px;
    height: 30px;
    right: 0px;
    top: 1px;
    color: #fff;
    font-size: 24px;
    display: none;
    z-index: 99;
}
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
   .avatar-uploader .el-upload:hover .del {
       display: block;
   }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .input-file {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
      z-index: 99;
  }
</style>